module.exports = __webpack_public_path__ + "static/media/004.e6cbb671.jpg";